import React, { useState, useCallback } from 'react'
import { getInitialUser, handleAccessToken } from 'commons/utils/auth/auth'
import useEventListener from 'commons/hooks/useEventListener'
import { EventType } from 'commons/utils/event'
import { User, UserPermission, UserProfile } from 'commons/types/user'
import { PRODUCTOR, PRODUCTOR_MUSICAL, PRODUCTOR_CAST } from 'commons/constants/profiles'
import { Provider } from './context'

type Props = {
  children: React.ReactNode
}

const UserProvider = ({ children }: Props) => {
  const [user, setUser] = useState<User>(getInitialUser)

  useEventListener(EventType.SET_USER, (event: CustomEvent<string>) => {
    setUser(handleAccessToken(event.detail))
  })

  const hasProfile = useCallback(
    (...profiles: UserProfile[]) => profiles.some(profile => user.profiles.includes(profile)),
    [user]
  )

  const hasPermission = useCallback(
    (...permissions: UserPermission[]) => permissions.some(permission => user.permissions.includes(permission)),
    [user]
  )

  const isProducer = useCallback(() => hasProfile(PRODUCTOR, PRODUCTOR_MUSICAL, PRODUCTOR_CAST), [user])

  return <Provider value={{ user, setUser, hasProfile, hasPermission, isProducer }}>{children}</Provider>
}

export default UserProvider
